var _defs, _path, _g, _use, _use2, _use3, _use4, _use5, _use6, _use7, _g2, _g3, _use8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWorldFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "-600 -400 1200 800"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "World_Flag_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0-200v400h200v-400zm-200 0v400h100v-400z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "World_Flag_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-200-200h400V50h-400z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "World_Flag_svg__f"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-200-150v300z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "World_Flag_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-200-200v400z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "World_Flag_svg__h"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-50-200h-150v350z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "World_Flag_svg__i"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-200h-200v400z"
})), /*#__PURE__*/React.createElement("circle", {
  id: "World_Flag_svg__a",
  r: 145.663,
  fill: "none",
  stroke: "#013ba6",
  strokeWidth: 39.03
}), /*#__PURE__*/React.createElement("circle", {
  id: "World_Flag_svg__c",
  r: 145.663,
  fill: "none",
  stroke: "#fff",
  strokeWidth: 17.347
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#013ba6",
  d: "M-600-400H600v800H-600z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "World_Flag_svg__d",
  transform: "translate(145.663)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#World_Flag_svg__a",
  clipPath: "url(#World_Flag_svg__b)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#World_Flag_svg__c"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#World_Flag_svg__d",
  transform: "rotate(-60)"
})), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#World_Flag_svg__d",
  transform: "rotate(60)"
})), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#World_Flag_svg__d",
  transform: "rotate(120)"
})), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#World_Flag_svg__d",
  transform: "rotate(180)"
})), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#World_Flag_svg__d",
  transform: "rotate(240)"
})), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#World_Flag_svg__a",
  clipPath: "url(#World_Flag_svg__e)"
})), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#World_Flag_svg__c"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(145.663)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#World_Flag_svg__a",
  clipPath: "url(#World_Flag_svg__f)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#World_Flag_svg__c",
  clipPath: "url(#World_Flag_svg__g)"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  id: "World_Flag_svg__j",
  transform: "rotate(120 -72.832 42.05)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#World_Flag_svg__a",
  clipPath: "url(#World_Flag_svg__h)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#World_Flag_svg__c",
  clipPath: "url(#World_Flag_svg__i)"
}))), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#World_Flag_svg__j",
  transform: "scale(-1 1)"
})));
export { SvgWorldFlag as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjkwMCIgaGVpZ2h0PSI2MDAiIHZpZXdCb3g9Ii02MDAgLTQwMCAxMjAwIDgwMCI+DQo8ZGVmcz4NCjxjaXJjbGUgaWQ9InJiIiByPSIxNDUuNjYzMjkzIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMTNiYTYiIHN0cm9rZS13aWR0aD0iMzkuMDMwMzYyIi8+DQo8Y2lyY2xlIGlkPSJydyIgcj0iMTQ1LjY2MzI5MyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjE3LjM0NjgyNyIvPg0KPGNsaXBQYXRoIGlkPSJvIj48cGF0aCBkPSJNMCwtMjAwVjIwMEgyMDBWLTIwMHpNLTIwMCwtMjAwVjIwMEgtMTAwVi0yMDB6Ii8+PC9jbGlwUGF0aD4NCjxjbGlwUGF0aCBpZD0iaCI+PHBhdGggZD0iTS0yMDAsLTIwMEgyMDBWNTBILTIwMHoiLz48L2NsaXBQYXRoPg0KPGNsaXBQYXRoIGlkPSJpMSI+PHBhdGggZD0iTTAsMCAtMjAwLC0xNTBWMTUweiIvPjwvY2xpcFBhdGg+DQo8Y2xpcFBhdGggaWQ9ImkyIj48cGF0aCBkPSJNMCwwIC0yMDAsLTIwMFYyMDB6Ii8+PC9jbGlwUGF0aD4NCjxjbGlwUGF0aCBpZD0ibDEiPjxwYXRoIGQ9Ik0wLDAgLTUwLC0yMDBILTIwMFYxNTB6Ii8+PC9jbGlwUGF0aD4NCjxjbGlwUGF0aCBpZD0ibDIiPjxwYXRoIGQ9Ik0wLDBWLTIwMEgtMjAwVjIwMHoiLz48L2NsaXBQYXRoPg0KPC9kZWZzPg0KPHJlY3Qgd2lkdGg9IjEyMDAiIGhlaWdodD0iODAwIiB4PSItNjAwIiB5PSItNDAwIiBmaWxsPSIjMDEzYmE2Ii8+DQo8ZyBpZD0icm8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0NS42NjMyOTMsMCkiPg0KPHVzZSB4bGluazpocmVmPSIjcmIiIGNsaXAtcGF0aD0idXJsKCNvKSIvPg0KPHVzZSB4bGluazpocmVmPSIjcnciLz4NCjwvZz4NCjx1c2UgeGxpbms6aHJlZj0iI3JvIiB0cmFuc2Zvcm09InJvdGF0ZSgtNjApIi8+DQo8dXNlIHhsaW5rOmhyZWY9IiNybyIgdHJhbnNmb3JtPSJyb3RhdGUoNjApIi8+DQo8dXNlIHhsaW5rOmhyZWY9IiNybyIgdHJhbnNmb3JtPSJyb3RhdGUoMTIwKSIvPg0KPHVzZSB4bGluazpocmVmPSIjcm8iIHRyYW5zZm9ybT0icm90YXRlKDE4MCkiLz4NCjx1c2UgeGxpbms6aHJlZj0iI3JvIiB0cmFuc2Zvcm09InJvdGF0ZSgyNDApIi8+DQo8Zz4NCjx1c2UgeGxpbms6aHJlZj0iI3JiIiBjbGlwLXBhdGg9InVybCgjaCkiLz4NCjx1c2UgeGxpbms6aHJlZj0iI3J3Ii8+DQo8L2c+DQo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDUuNjYzMjkzLDApIj4NCjx1c2UgeGxpbms6aHJlZj0iI3JiIiBjbGlwLXBhdGg9InVybCgjaTEpIi8+DQo8dXNlIHhsaW5rOmhyZWY9IiNydyIgY2xpcC1wYXRoPSJ1cmwoI2kyKSIvPg0KPC9nPg0KPGcgaWQ9InJsIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIHRyYW5zbGF0ZSgxNDUuNjYzMjkzLDApIj4NCjx1c2UgeGxpbms6aHJlZj0iI3JiIiBjbGlwLXBhdGg9InVybCgjbDEpIi8+DQo8dXNlIHhsaW5rOmhyZWY9IiNydyIgY2xpcC1wYXRoPSJ1cmwoI2wyKSIvPg0KPC9nPg0KPHVzZSB4bGluazpocmVmPSIjcmwiIHRyYW5zZm9ybT0ic2NhbGUoLTEsMSkiLz4NCjwvc3ZnPg==";